/**
 * Reloads the browser after a specified delay
 * @param delay - Delay in milliseconds before reloading (default: 100)
 */
export const reloadBrowser = (delay: number = 100): void => {
  setTimeout(() => {
    window.location.reload();
  }, delay);
};
